module.exports = __webpack_public_path__ + "img/download-2-4INT.22a45d5e.png";